<template>
  <section class="no-data-wrap">
    <section class="no-data-container">
      <span v-if="tip === 'fail'">{{ $t('monitor.fail') }}</span>
      <span v-else-if="tip === 'empty'">{{ $t('monitor.noData') }}</span>
      <span v-else
        ><i class="el-icon-loading"></i
        ><span>{{ $t('monitor.loading') }}</span></span
      >
    </section>
  </section>
</template>

<script>
export default {
  props: ['tip']
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';
.no-data-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 14px;
}
.no-data-container {
  @extend .no-data-wrap;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bbb;
  position: absolute;
  top: 0;
  left: 0;
  span {
    font-size: vw(15);
  }
  i {
    margin-right: 5px;
  }
}
</style>
